// extracted by mini-css-extract-plugin
export default {"header":"TableScrollArea_header__ODqFW","scrolled":"TableScrollArea_scrolled__lDXVY","m-4e7aa4ef_mantine-Table-td":"TableScrollArea_m-4e7aa4ef_mantine-Table-td__apiA4"};